import { useEffect, useState } from 'react';
import { Input } from '../Input';

interface CheckoutDateInputsProps {
  deliveryFrom?: string;
  deliveryTo?: string;
  handleSiloDateUpdate: (date: string, type: string) => void;
  t: any;
}

const CheckoutDateInputs: React.FC<CheckoutDateInputsProps> = ({
  deliveryFrom = '',
  deliveryTo = '',
  handleSiloDateUpdate,
  t,
}) => {
  const [fromError, setFromError] = useState<string>('');
  const [toError, setToError] = useState<string>('');

  useEffect(() => {
    if (!deliveryFrom) {
      setFromError('Dieses Feld ist erforderlich');
    } else {
      setFromError('');
    }

    if (!deliveryTo) {
      setToError('Dieses Feld ist erforderlich');
    } else {
      setToError('');
    }
  }, [deliveryFrom, deliveryTo]);

  const handleDeliveryDateChange = (key: string, value: string | number) => {
    if (!value) {
      if (key === 'from') {
        setFromError('Dieses Feld ist erforderlich');
      } else if (key === 'to') {
        setToError('Dieses Feld ist erforderlich');
      }
    }

    // Clear error when value is provided
    if (key === 'from') {
      setFromError('');
    } else if (key === 'to') {
      setToError('');
    }

    handleSiloDateUpdate(key, value.toString());
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-1-0">
      <Input
        label={t('checkout.delivery_from')}
        id="from"
        type="date"
        data-testid="silo-input-from"
        defaultValue={deliveryFrom}
        onChange={handleDeliveryDateChange}
        error={fromError}
      />
      <Input
        label={t('checkout.delivery_to')}
        id="to"
        type="date"
        defaultValue={deliveryTo}
        data-testid="silo-input-to"
        onChange={handleDeliveryDateChange}
        error={toError}
      />
    </div>
  );
};

export default CheckoutDateInputs;
